import { render, staticRenderFns } from "./onLgcd.vue?vue&type=template&id=50ccbb1b&scoped=true"
import script from "./onLgcd.vue?vue&type=script&lang=js"
export * from "./onLgcd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ccbb1b",
  null
  
)

export default component.exports